<template>
  <div @click="onClick" class="action-container">
    <div class="image-container">
      <img class="header-image" :src="require(`@/assets/icons/${icon}.svg`)">
    </div>
    <div class="action-name">{{text}}</div>
  </div>
</template>

<script>

export default {
  name: 'Action',
  props: {
    icon: String,
    text: String,
    onClick: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~base-ui/src/scss/riseup-colors';
  .action-container {
    display: flex;
    justify-content: flex-start;
    height: 55px;
    align-items: center;
    color: $riseup_gray_-1;
    cursor: pointer;
    .image-container {
      display: flex;
      align-items: center;
      width: 42px;
      .header-image {
        margin: 0 auto;
        padding-top: 5px;
      }
    }
    .action-name {
      padding-right: 10px;
      font-size: 14px;
      font-weight: bold;
    }
  }
</style>
